module.exports = "files/stomp1.mp3";